import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from './Settings.styles';
import { Benchmarks } from './Benchmarks/Benchmarks';
import { Data } from './Data/Data';
import { Preferences } from './Preferences/Preferences';
import { ClassificationRules } from 'views/ClassificationRules';
import { ApiContext } from 'context/ApiContext';
import { ISettingsResponse } from 'utils/types';
import {
  PERMISSIONS,
  DATA_PERMISSIONS,
  hasSomeOfRequiredPermissions,
} from 'utils/constants';

export const SettingsView = ({
  permissions,
  settings,
}: {
  permissions: string[];
  settings: ISettingsResponse;
}) => {
  const isPreferencesTabAvailable = permissions.includes(
    PERMISSIONS.PREFERENCES_READ
  );

  if (!settings && isPreferencesTabAvailable) {
    return null;
  }

  const isDataTabAvailable = hasSomeOfRequiredPermissions(
    permissions,
    DATA_PERMISSIONS
  );
  const isClassificationTabAvailable = permissions.includes(
    PERMISSIONS.CLASSIFICATION_RULES_READ
  );
  const isBenchmarksTabAvailable = permissions.includes(
    PERMISSIONS.BENCHMARK_SETTINGS_READ
  );

  const isSettingsAvailable =
    settings &&
    settings.availableRange.startYear &&
    settings.availableRange.endYear &&
    isPreferencesTabAvailable;
  const redirectUrl = isSettingsAvailable
    ? '/settings/preferences'
    : isDataTabAvailable
    ? '/settings/data'
    : isClassificationTabAvailable
    ? '/settings/classification'
    : isBenchmarksTabAvailable
    ? '/settings/benchmarks'
    : '/';

  return (
    <Container>
      <Switch>
        {isDataTabAvailable && <Route path="/settings/data" component={Data} />}
        {isBenchmarksTabAvailable && (
          <Route exact path="/settings/benchmarks" component={Benchmarks} />
        )}
        {isPreferencesTabAvailable && (
          <Route exact path="/settings/preferences" component={Preferences} />
        )}
        {isClassificationTabAvailable && (
          <Route
            path="/settings/classification"
            component={ClassificationRules}
          />
        )}
        <Redirect to={redirectUrl} />
      </Switch>
    </Container>
  );
};

export const Settings = () => (
  <ApiContext.Consumer>
    {({ permissions, settings }) => (
      <SettingsView permissions={permissions} settings={settings} />
    )}
  </ApiContext.Consumer>
);
